import Banner from '@/components/Banner2';
import Title from '@/components/Title/index.vue';
import Card from '@/components/Card/index.vue';
import BusiCard from '@/components/BusiCard/index.vue';
import Advantages2 from '@/components/Advantages2';
import Appointment2 from '@/components/Appointment2/index.vue';
export default {
  components: {
    Banner,
    Title,
    Card,
    BusiCard,
    Advantages2,
    Appointment2
  },
  data() {
    return {
      bannerData: {
        imageUrl: require('@/assets/images/technology/ContractComparison/ContractComparison-banner.png'),
        bannerTitle: '合同文档比对',
        bannerText: '通过NLP和NLU以及大数据分析等技术，自动化审核各种合同文档，并对多份文档进行差异对比'
      },
      functionsData: [{
        img: require('@/assets/images/technology/ContractComparison/contractcomparsion-func1.png'),
        title: '文档评审',
        desc: '智能识别、提取并分析各种合同文档的内容'
      }, {
        img: require('@/assets/images/technology/ContractComparison/contractcomparsion-func2.png'),
        title: '跨文档评审',
        desc: '多文档交叉对比文档内容差异并标记'
      }],
      applicationsData: [{
        icon: require('@/assets/images/technology/ContractComparison/contractcomparsion-app1.png'),
        title: '验证多份同源合同文档',
        text: '对于同一个合同的多份文档，通过多文档对比系统，可以识别并标记出有差别的地方'
      }, {
        icon: require('@/assets/images/technology/ContractComparison/contractcomparsion-app2.png'),
        title: '对比历史合同差异',
        text: '合同有历史变更记录以及续签合同更改部分内容，可通过多文档对比系统识别差异'
      }],
      advantagesData1: [{
        title: '合同类型多',
        desc: '支持多种类型的合同文档对比审核，有效应对多种场景下的合同文档对比需求'
      }],
      advantagesData2: [{
        title: '服务灵活',
        desc: '提供在线网站和离线工具两种服务形式，灵活响应客户需求'
      }]
    };
  }
};